import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoOngoingMissingInventoryEmailEditTemplate } from 'themes/application/niko-ongoing-missing-inventory/pages';
import { OngoingMissingInventoryEmailEditViewStore } from 'application/ongoing-missing-inventory/stores';

@setCurrentView((rootStore) => new OngoingMissingInventoryEmailEditViewStore(rootStore), 'ongoingMissingInventoryEmailEditViewStore')
@observer
class NikoOngoingMissingInventoryEmailEdit extends React.Component {
    render() {
        return <NikoOngoingMissingInventoryEmailEditTemplate {...this.props} />
    }
}

export default NikoOngoingMissingInventoryEmailEdit;
